<div class="form-group" [formGroup]="group">
    <label [ngClass]="{'required': isFieldRequired}">{{name}}</label>
    <input name="number"
           type="number"
           formControlName="Text"
           class="form-control form-control-lg input-full"
           placeholder="{{ placeholder}}">
    <ips-show-errors [control]="group.get('Text')" [errorMessages]="getErrorMessages()"></ips-show-errors>
</div>
